import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcContactPanel from '@contacts/components/panels/contact-panel/contact-panel.vue';

import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-contact-profile',
  components: {
    'bpc-contact-panel': BpcContactPanel,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class ContactProfile extends Vue {
  get tenantAlias(): string {
    const tenant = this.$authService.getSelectedTenant();
    return tenant.alias || 't';
  }

  get gridView(): boolean {
    return this.currentRoute === 'contact-profile-dashboard';
  }

  get currentRoute() {
    return this.$route.name;
  }

  get contactId() {
    return this.$authorizationService.getContactId();
  }

  get allowOnlineOrganizationBooking() {
    return this.$authService.getIsAllowedToOnlineOrganizationBooking();
  }

  get dashboardRoute(): string {
    return this.$clientRouter.getClientUrl(`profile`);
  }

  get showMenuEntries(): string[] {
    return this.isIndividual
      ? this.$store.getters['centerSettings/centerSettings']?.show_menu_entries || []
      : this.$store.getters['centerSettings/centerSettings']?.show_menu_entries_for_organization ||
          [];
  }

  get lang() {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get isIndividual(): boolean {
    return this.$authService.getIsIndividual();
  }

  public menuContact = [];
  public get filteredMenuContact() {
    this.menuContact = [
      {
        href: this.$clientRouter.getClientUrl(`profile/bookings`),
        icon: 'lnr-calendar-full',
        name: 'bookings',
        title: this.$t('global.profile.menu.bookings.title'),
        description: this.$t('global.profile.menu.bookings.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('bookings'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/my-booking-requests`),
        icon: 'lnr-calendar-full',
        name: 'bookings',
        title: this.$t('global.profile.menu.my_booking_requests.title'),
        description: this.$t('global.profile.menu.my_booking_requests.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['manage_bookings', 'manage_public_bookings'], // TODO: JJFC check this permissions
        hidden: !this.showMenuEntries.includes('my-booking-requests'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/new-booking`),
        icon: 'lnr-plus-circle',
        bgVariant: 'success',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'book-resource',
        title: this.$t('global.profile.menu.book_resource.title'),
        description: this.$t('global.profile.menu.book_resource.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['manage_bookings', 'manage_public_bookings'],
        hidden:
          !this.showMenuEntries.includes('book-resource') ||
          this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/online-booking`),
        icon: 'lnr-plus-circle',
        bgVariant: 'success',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'book-resource',
        title: this.$t('global.profile.menu.book_resource.title'),
        description: this.$t('global.profile.menu.book_resource.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['manage_bookings', 'manage_public_bookings'],
        hidden:
          !this.showMenuEntries.includes('book-resource') ||
          !this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/new-organization-booking`),
        icon: 'lnr-plus-circle',
        bgVariant: 'success',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'organization-book-resource',
        title: this.$t('global.profile.menu.organization_book_resource.title'),
        description: this.$t('global.profile.menu.organization_book_resource.description'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['manage_bookings', 'manage_public_bookings'],
        hidden:
          !this.showMenuEntries.includes('organization-book-resource') ||
          this.isIndividual ||
          (!this.isIndividual && !this.allowOnlineOrganizationBooking),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/enrollments`),
        icon: 'lnr-heart-pulse',
        name: 'enrollments',
        title: this.$t('global.profile.menu.enrollments.title'),
        description: this.$t('global.profile.menu.enrollments.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('enrollments'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/activity-sessions`),
        icon: 'lnr-calendar-full',
        name: 'activity-sessions',
        title: this.$t('global.profile.menu.activity_sessions.title'),
        description: this.$t('global.profile.menu.activity_sessions.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('activity-sessions'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/attendees`),
        icon: 'lnr-calendar-full',
        name: 'attendees',
        title: this.$t('global.profile.menu.attendees.title'),
        description: this.$t('global.profile.menu.attendees.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('attendees'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/activities`),
        icon: 'lnr-magnifier',
        bgVariant: 'primary',
        textVariant: 'white',
        // onlyGrid: true,
        name: 'activities',
        title: this.$t('global.profile.menu.search_activity.title'),
        description: this.$t('global.profile.menu.search_activity.description'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        permissions: ['read_activities'],
        hidden: !this.showMenuEntries.includes('activities'),
      },
      // {
      //   href: this.$clientRouter.getClientUrl(`profile/activities`),
      //   icon: 'lnr-magnifier',
      //   onlyBreadcrumbs: true,
      //   name: 'activity-details',
      //   title: this.$t('global.profile.menu.activity_details.title'),
      //   description: this.$t('global.profile.menu.activity_details.description'),
      //   module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      // },
      {
        href: this.$clientRouter.getClientUrl(`profile/subscriptions`),
        icon: 'lnr-license',
        name: 'subscriptions',
        title: this.$t('global.profile.menu.subscriptions.title'),
        description: this.$t('global.profile.menu.subscriptions.description'),
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('subscriptions'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/subscriptions-available`),
        icon: 'lnr-license',
        bgVariant: 'secondary',
        textVariant: 'white',
        name: 'subscriptions-available',
        title: this.$t('global.profile.menu.subscriptions_available.title'),
        description: this.$t('global.profile.menu.subscriptions_available.description'),
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('subscriptions-available'),
      },
      {
        href: this.$clientRouter.getClientUrl(`web/${this.lang}/sales/entries`),
        icon: 'lnr-tag',
        name: 'entries',
        title: this.$t('global.profile.menu.entries.title'),
        description: this.$t('global.profile.menu.entries.description'),
        module: ModulesHelper.ENTRIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('entries-available'),
        refresh: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`web/${this.lang}/profile/my-entries`),
        icon: 'lnr-tag',
        name: 'my-entries',
        title: this.$t('global.show_menu_entries_my_entries_title'),
        description: this.$t('global.show_menu_entries_my_entries_description'),
        module: ModulesHelper.ENTRIES_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('entries'),
        refresh: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/orders`),
        icon: 'lnr-book',
        name: 'orders',
        title: this.$t('global.profile.menu.orders.title'),
        description: this.$t('global.profile.menu.orders.description'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('orders'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/invoices`),
        icon: 'lnr-book',
        name: 'invoices',
        title: this.$t('global.profile.menu.invoices.title'),
        description: this.$t('global.profile.menu.invoices.description'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('invoices'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/contracts`),
        icon: 'lnr-inbox',
        name: 'contracts',
        title: this.$t('global.profile.menu.contracts.title'),
        description: this.$t('global.profile.menu.contracts.description'),
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('contracts'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/contact`),
        icon: 'lnr-user',
        name: 'contact',
        title: this.$t('global.profile.menu.my_contact_details.title'),
        description: this.$t('global.profile.menu.my_contact_details.description'),
        hidden: !this.showMenuEntries.includes('contact'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/edit-password`),
        icon: 'lnr-lock',
        name: 'edit-password',
        title: this.$t('global.profile.menu.edit_password.title'),
        description: this.$t('global.profile.menu.edit_password.description'),
        hidden: !this.showMenuEntries.includes('edit-password'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/family`),
        icon: 'lnr-users',
        name: 'family',
        title: this.$t('global.profile.menu.my_family.title'),
        description: this.$t('global.profile.menu.my_family.description'),
        hidden: !this.showMenuEntries.includes('family'),
      },
      {
        href: this.$clientRouter.getClientUrl(`profile/mailbox`),
        icon: 'lnr-envelope',
        name: 'mailbox',
        title: this.$t('global.profile.menu.messages.title'),
        description: this.$t('global.profile.menu.messages.description'),
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
        hidden: !this.showMenuEntries.includes('mailbox'),
      },
    ];

    return this.menuContact.filter(item => {
      return (
        !item.hidden &&
        (item.module
          ? this.$modulesService.hasModuleActivated(item.module)
          : item.modules
          ? this.$modulesService.hasSomeModuleActivated(item.modules)
          : true) &&
        (item.permissions ? this.$authorizationService.hasPermissions(item.permissions) : true)
      );
    });
  }

  // updated() {}
  // destroyed() {}
}
